import JournalAdvancedSearch from './JournalAdvancedSearch';
import JournalDetail from './JournalDetail';
import JournalList from './JournalList';
import JournalTop from './JournalTop';

const ItemTypeJournal = {
    Top: JournalTop,
    List: JournalList,
    Detail: JournalDetail,
    AdvancedSearch: JournalAdvancedSearch,
};

export default ItemTypeJournal;
